module.exports = __webpack_public_path__ + "img/sleep.055c32c9.svg";